import { LoadingScreen } from "@packsize/components";
import { useEffect, useState } from "react";
import { useSearchParams, Navigate } from "react-router-dom";

import type { SsoFailureReason } from "../../schemas";
import { useToken } from "../../hooks";

const TIMEOUT_MS = 10 * 1000;

export const LoginSsoVerify = () => {
	const { setToken } = useToken();
	const [error, setError] = useState<SsoFailureReason>();

	const [search] = useSearchParams();
	const token = search.get("token");

	useEffect(() => {
		if (!token) {
			setError("no-token");
			return;
		}

		if (token.includes(".")) {
			setToken(token);
			return;
		}

		try {
			const decodedToken = atob(token);
			setToken(decodedToken);
		} catch {
			setError("invalid-token");
		}
	}, [setToken, token]);

	useEffect(() => {
		const timeout = setTimeout(() => setError("timeout"), TIMEOUT_MS);

		return () => {
			clearTimeout(timeout);
		};
	}, []);

	if (error) {
		search.set("reason", error);

		return (
			<Navigate
				to={{
					pathname: `/login-sso-error`,
					search: search.toString(),
				}}
				replace
			/>
		);
	}

	return <LoadingScreen />;
};
